import { graphql } from "react-relay";

export const QUERY = graphql`
	query reportDetails_Query($reportId: ID!, $skip: Boolean!) {
		node(id: $reportId) @skip(if: $skip) {
			... on DSAReport {
				id
				data {
					problemType
					reportType
					extra
					lastName
					firstName
					email
					url
				}
				referenceNumber
				createdAt
			}
		}
	}
`;
